import { IInativarBiometriaFacialUseCase } from "../../../presentation/useCases/delete/delete_biometria_facial_case";
import { IRhRepository } from "../../repositories/rh_repository";

export class InativarBiometriaFacialUseCase implements IInativarBiometriaFacialUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async inativarBiometriaFacial(
    idFuncionario: number,
  ): Promise<void> {
    await this.repository.inativarBiometriaFacial(idFuncionario);
  }
}
